// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {getCreditMemoFormName, getCreditMemoObjectId} from '../../../../shared/services/credit-memo-services';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import {FormattedMessage} from 'react-intl';
import SmartFormLink from '../../../../shared/components/smart-form-link/smart-form-link';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const actionLinkMap = props => ({
    APLYPIP: (
        <span
            className='hidden-disabled-action'
        >
            <FormattedMessage id={props.action.actionName}/>
        </span>
    ),
    CRDMEM: (
        <SmartFormLink
            displayText={props.action.actionName}
            formName={getCreditMemoFormName(props.creditMemoNumber)}
            objectId={getCreditMemoObjectId(props.creditMemoNumber, props.claimNumber)}
            translate={true}
        />
    ),
    DIS_VSR: (
        <span
            className='hidden-disabled-action'
        >
            <FormattedMessage id={props.action.actionName}/>
        </span>
    ),
    PRNT_CLM: (
        <SmartFormLink
            displayText={props.action.actionName}
            formName='CLAIM'
            objectId={props.claimNumber}
            translate={true}
        />
    )
}[props.action.id]);

const ActionButton = (props, context) => {

    const linkComponent = actionLinkMap(props, context);

    return linkComponent ? linkComponent : (
        <button
            className='button-text'
            onClick={props.onActionClick.bind(null, props.action)}
        >
            <FormattedMessage id={props.action.actionName}/>
        </button>
    );

};

ActionButton.displayName = 'ActionButton';
ActionButton.propTypes = {
    action: PropTypes.instanceOf(ClaimAction).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    creditMemoNumber: PropTypes.string.isRequired,
    onActionClick: PropTypes.func.isRequired
};
ActionButton.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-action-button/claim-action-button.js